'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Option = function () {
  function Option(input) {
    return typeof input === 'function';
  }

  ;
  Object.defineProperty(Option, Symbol.hasInstance, {
    value: function value(input) {
      return Option(input);
    }
  });
  return Option;
}();

var WidgetRegisterContract = exports.WidgetRegisterContract = function () {
  function WidgetRegisterContract(input) {
    return input != null && (input.widget instanceof Node || typeof input.widget === 'function') && typeof input.name === 'string' && (input.options === undefined || input.options != null && _typeof(input.options) === 'object' && Object.keys(input.options).every(function (key) {
      var _key = input.options[key];
      return Option(_key);
    }));
  }

  ;
  Object.defineProperty(WidgetRegisterContract, Symbol.hasInstance, {
    value: function value(input) {
      return WidgetRegisterContract(input);
    }
  });
  return WidgetRegisterContract;
}();


//////////////////
// WEBPACK FOOTER
// ../lib/types/widgets.js
// module id = 182
// module chunks = 0